import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const StyledError = styled.span`
  ${tw`text-xs text-red-500`};
`;

interface Props {
  text: string;
}

const Card: FC<Props> = ({ text }) => <StyledError>{text}</StyledError>;

export default Card;
